interface ListItem {
  key: string;
  value: string;
}

async function getSpam(list: ListItem[], wsgnver: string = 'secure') {
  const time = new Date().getTime().toString();
  let kp = '';
  let ut = '';
  let ve = '';
  const tmp: any = await Promise.all([getParams(), getkps()]);
  if (tmp?.length == 2) {
    kp = tmp[0]?.kp || tmp[1] || '';
    ut = tmp[0]?.ut || '';
    ve = tmp[0]?.ve || '';
  }

  let params: string = '';
  let inputStr = `${ut}${ve}${kp}`; // ${ut}${ve}${kp}${page}${q}
  list.forEach((item: ListItem, index) => {
    params += index === 0 ? `${item.key}` : `,${item.key}`;
    inputStr += `${item.value}`; // ${ut}${ve}${kp}${page}${q}
  });

  const sign = await spamSignFun(inputStr, time);
  return {
    sign2: inputStr,
    params,
    sign,
    time,
    wsgnver,
    kp: kp, // 这三个参数url公参应该有
    ut: ut,
    ve: ve,
  };
}

async function getkps() {
  return new Promise((resolve) => {
    // @ts-ignore
    if (window?.ucapi?.invoke) {
      // @ts-ignore
      window?.ucapi?.invoke('account.getUserInfo', {
        vCode: new Date().getTime(), // 加密 code，一般使用时间戳
        needThirdAccount: true, // 仅 Android 需要：需要三方账号信息 thirdPartyAccount 时用（可能会异步网络获取）
        success: function (data: any) {
          resolve(data?.kps_wg);
        },
        fail: function () {
          resolve('');
        },
      });
    } else {
      resolve('');
    }
  });
}

async function getParams() {
  return new Promise((resolve) => {
    // @ts-ignore
    if (window?.ucapi?.invoke) {
      // @ts-ignore
      window?.ucapi?.invoke('biz.ucparams', {
        params: 'utvekp', // 公参
        isHttps: true, //	是否要https的公参，https的公参不用无线保镖加密，默认为false
        urlencode: false, // 返回参数是否要进行urlencode。默认情况下，android 做urlencode、iOS不做（历史原因）
        success: function (data: any) {
          resolve(data);
        },
        fail: function () {
          resolve({});
        },
      });
    } else {
      resolve({});
    }
  });
}

async function spamSignFun(text: string, salt: string) {
  return new Promise((resolve) => {
    // @ts-ignore
    if (window?.ucapi?.invoke) {
      // @ts-ignore
      window?.ucapi?.invoke('spam.sign', {
        text: text, // 加签内容
        salt: salt, // 业务自定义 ("盐值")、 业务和后端定义规范即可. eg: 冬签邀请码示例: text: 邀请码， salt: 用户 uId
        method: 'secure', // 新增参数，支持版本：Android、iOS >= 12.1.2。增加虚机签名支持。增加 method 参数，值为 secure，或者 avmp
        success: function (data: any) {
          resolve(data?.output_text);
        },
        fail: function () {
          resolve('');
        },
      });
    } else {
      resolve('');
    }
  });
}

const getChid = () => {
  return `${Date.now()}_${Math.floor(Math.random() * 100000)}`;
};
export { getSpam, getChid };
